import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabase';
import { FaUserShield, FaUsers, FaMapMarkerAlt, FaBuilding, FaArrowLeft } from 'react-icons/fa';

export default function SocietyProfile() {
  const { id } = useParams(); // URL se ID lega (e.g. /society/1)
  const [society, setSociety] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchSocietyData = async () => {
      const { data, error } = await supabase
        .from('societies')
        .select('*')
        .eq('id', id)
        .single();

      if (error) {
        console.error("Error fetching society:", error);
        navigate('/login'); // Agar ID galat ho toh wapas bhej do
      } else {
        setSociety(data);
      }
      setLoading(false);
    };

    fetchSocietyData();
  }, [id, navigate]);

  if (loading) return <div style={styles.loader}>INITIALIZING_SOCIETY_UNIT...</div>;

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        {/* Top Section: Society Details */}
        <div style={styles.header}>
          <div style={styles.iconCircle}>
            <FaBuilding style={{ fontSize: '40px', color: '#00e0ff' }} />
          </div>
          <h1 style={styles.societyName}>{society?.name || "SOCIETY_NAME"}</h1>
          <p style={styles.location}>
            <FaMapMarkerAlt /> {society?.location || "LOCATION_NOT_SET"}
          </p>
          <div style={styles.badge}>UNIT_CODE: EF_00{society?.id}</div>
        </div>

        <div style={styles.divider} />

        {/* Choice Section: Two Login Paths */}
        <div style={styles.grid}>
          {/* Path A: Chairman */}
          <div style={styles.loginBox} onClick={() => navigate(`/login/admin/${id}`)}>
            <FaUserShield style={styles.boxIcon} />
            <h3 style={styles.boxTitle}>CHAIRMAN LOGIN</h3>
            <p style={styles.boxDesc}>Management, Staff, & Society Control</p>
            <button style={styles.actionBtn}>ACCESS_ADMIN →</button>
          </div>

          {/* Path B: Member */}
          <div style={styles.loginBox} onClick={() => navigate(`/login/member/${id}`)}>
            <FaUsers style={styles.boxIcon} />
            <h3 style={styles.boxTitle}>MEMBER LOGIN</h3>
            <p style={styles.boxDesc}>Notices, Bills, & Resident Updates</p>
            <button style={styles.actionBtn}>ACCESS_PORTAL →</button>
          </div>
        </div>

        <button onClick={() => navigate('/login')} style={styles.backLink}>
          <FaArrowLeft /> CHANGE SOCIETY
        </button>
      </div>
    </div>
  );
}

const styles = {
  container: { minHeight: '100vh', background: '#02040a', display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '20px', fontFamily: 'monospace' },
  card: { background: 'rgba(255, 255, 255, 0.01)', border: '1px solid #00e0ff22', padding: '60px 40px', borderRadius: '8px', width: '100%', maxWidth: '850px', textAlign: 'center', backdropFilter: 'blur(10px)' },
  header: { marginBottom: '40px' },
  iconCircle: { background: '#00e0ff11', width: '80px', height: '80px', borderRadius: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center', margin: '0 auto 20px', border: '1px solid #00e0ff33' },
  societyName: { color: '#fff', fontSize: '32px', letterSpacing: '3px', margin: '10px 0', textTransform: 'uppercase' },
  location: { color: '#888', fontSize: '14px', letterSpacing: '1px', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' },
  badge: { display: 'inline-block', marginTop: '15px', padding: '4px 12px', border: '1px solid #00e0ff55', color: '#00e0ff', fontSize: '10px', fontWeight: 'bold' },
  divider: { height: '1px', background: 'linear-gradient(90deg, transparent, #00e0ff33, transparent)', margin: '40px 0' },
  grid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '30px' },
  loginBox: { background: '#05070a', border: '1px solid #111', padding: '40px 20px', cursor: 'pointer', transition: '0.3s ease', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '15px' },
  boxIcon: { fontSize: '45px', color: '#00e0ff', marginBottom: '10px' },
  boxTitle: { color: '#fff', fontSize: '18px', margin: 0 },
  boxDesc: { color: '#555', fontSize: '12px' },
  actionBtn: { background: 'transparent', border: '1px solid #00e0ff', color: '#00e0ff', padding: '10px 20px', fontSize: '11px', fontWeight: 'bold', cursor: 'pointer', marginTop: '10px' },
  backLink: { background: 'none', border: 'none', color: '#444', marginTop: '50px', cursor: 'pointer', fontSize: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' },
  loader: { height: '100vh', background: '#02040a', color: '#00e0ff', display: 'flex', justifyContent: 'center', alignItems: 'center', fontFamily: 'monospace' }
};